import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchAuctionByAktenzeichen, fetchMyBids } from '@/services/api';
import type { Database } from '@/lib/database.types';

type BidRow = Database['public']['Tables']['bids']['Row'];

function formatCurrency(value: number): string {
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
}

function formatDateTime(dateStr: string): string {
  return new Date(dateStr).toLocaleString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
}

export function BidHistoryPage() {
  const { aktenzeichen } = useParams<{ aktenzeichen: string }>();
  const [bids, setBids] = useState<BidRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!aktenzeichen) return;

    async function load() {
      // Fetch all bids, client-side filters to own (RLS already filters)
      const data = await fetchMyBids('');
      setBids(data);
      setLoading(false);
    }

    load();
  }, [aktenzeichen]);

  if (loading) return <div className="max-w-content mx-auto py-12"><p className="text-text-secondary">Laden...</p></div>;

  return (
    <div className="max-w-content mx-auto py-12">
      <h1 className="text-2xl font-serif mb-6">Meine Gebotshistorie</h1>

      {bids.length === 0 ? (
        <p className="text-text-secondary text-sm">Keine Gebote vorhanden.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Datum</th>
              <th>Betrag</th>
              <th>Ergebnis</th>
            </tr>
          </thead>
          <tbody>
            {bids.map((bid) => (
              <tr key={bid.id}>
                <td>{formatDateTime(bid.abgegeben_at)}</td>
                <td>{formatCurrency(bid.betrag)}</td>
                <td>—</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div className="mt-6">
        <Link to="/dashboard" className="btn-secondary">Zuruck zum Dashboard</Link>
      </div>
    </div>
  );
}
